var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"vtd-main-section",style:({ backgroundColor: '#fff' }),attrs:{"role":"main"}},[_c('MenuBar'),_c('article',{staticClass:"vtd-section-info"},[_vm._t("default")],2),_c('LoadingSpinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }